import React from "react";
import Layout from "@/components/layout/Layout";
import { SEOHead } from "@/components/seo/SEOHead";
import { ExpertApplicationForm } from "@/components/consultations/ExpertApplicationForm";
import { ExpertMarketplaceGuide } from "@/components/consultations/expert-form/ExpertMarketplaceGuide";

export default function ExpertApplicationPage() {
  return (
    <Layout>
      <SEOHead 
        title="Apply to Become an Expert | Grandpal"
        description="Join our marketplace of verified care placement experts. Help families navigate Fair Deal applications, care assessments, and placement decisions while setting your own rates."
        canonicalUrl="/apply-expert"
      />

      <div className="min-h-screen bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Join Our Expert Marketplace
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Share your expertise with families navigating care placement decisions. 
              Set your own rates, choose your schedule, and make a meaningful difference.
            </p>
          </div>

          {/* How the Expert Marketplace Works */}
          <div className="mb-16">
            <ExpertMarketplaceGuide />
          </div>

          <ExpertApplicationForm />
        </div>
      </div>
    </Layout>
  );
}
